<template>
<div class="container-fluid" >
  <button   @click="$emit('close')" type="button"  class="btn btn-secondary ml-1 mb-1">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A PARAMETRI RICERCA
  </button>    
   
  <button :disabled="spinnerPDF"  @click="printPDF()"  type="button" class="btn btn-primary ml-2 mb-1">
                  <i class="fas fa-file-export mr-2" aria-hidden="true"></i>
                  ESPORTA PDF 
                  <span v-if="spinnerPDF"  class="spinner-border spinner-border-sm ml-2 " role="status" aria-hidden="true"></span>
  </button>  
  

<div class="row">
<div class="col">


<div class="table-wrapper-scroll-y my-custom-scrollbar" id="table_div">
<table id='my-table' class="table table table-sm table-bordered mb-0">
  <thead >
    <tr class="table-primary">

      <th scope="col">ANNO</th>
      <th scope="col">STAGIONE</th>
      <th scope="col">REPARTO</th>      
      <th scope="col">PRODOTTI</th>
      <th scope="col">VAL. INIZIALE €</th>
      <th scope="col">VAL. VENDUTO €</th>
      <th class="text-nowrap" scope="col">VAL. VARIAZIONE €</th>
      <th scope="col">SCONTO MEDIO %</th>
      
      
         
    </tr>
  </thead>
  <tbody>
    <tr :style="{color: item.qty < 0  ? 'red' : 'black'}"   data-toggle="tooltip" title="" class="pointer"  v-for="(item, index) in filteredProducts" :key="index">
      

      <td class="text-nowrap">{{item.season_year}} </td>  
      
      <td >{{item.season}} </td>  
      <td >{{item.department}} </td>  

      <td class="text-right" >{{fmt2(item.qty)}}</td>    
      
      <td class="text-right">{{fmt1(item.totalRetail)}} </td>
      <td class="text-right">{{fmt1(item.totalSold)}} </td>
      <td class="text-right" >{{fmt1(item.priceDifference)}} </td>
      <td class="text-right"> {{item.totalDiscount}} % </td>

      
    </tr> 
  </tbody>
  <tfoot>
        <tr :style="{backgroundColor: '#FFFFE0', color: 'blue' ,fontSize: '20px', fontWeight: 'bold' }"  data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in totalRow" :key="index"> 
       
        
      <td></td>
      <td></td>
      <td> Totale</td>
      
      <td class="text-right" >{{fmt2(item.qty)}}</td>    
      <td class="text-right">{{fmt1(item.totalRetail)}} </td>
      <td class="text-right">{{fmt1(item.totalSold)}} </td>
      <td class="text-right" >{{fmt1(item.priceDifference)}} </td>
      <td class="text-right"> {{item.totalDiscount}} % </td>

        
        
        </tr>   
    </tfoot>    
</table>
</div>
<label  for="cerca"><strong>
  <i  class="fas fa-filter mr-2 mt-3" aria-hidden="true"></i>
    Filtra</strong></label>
<input class="form-control mb-3" type="text" name="query" v-model="filterProduct">

</div>

</div>


<alert-box class="mt-3" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
</div>

</template>
<script>

import { mapGetters }    from 'vuex';
import fmt               from '@/components/mixins/fmt'
import alertBox          from '@/components/common/AlertBox.vue';
import jsPDF             from 'jspdf';


export default {

  mixins     : [fmt],
  components : {alertBox},
  props : ['items','pdf'],

  data() {
    return {
   
   pdfItems      : [],
   totalRow      : [],   
   filterProduct : '',     
   
   spinnerPDF    : false,
   msg             : {

      title     : '',
      body      : '',
      type      : 0

    },
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
    filteredProducts : function () 
      {
        var filterProducts = this.filterProduct && this.filterProduct.toLowerCase()
        var items = this.items
        if (filterProducts) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterProducts) > -1
          })
        })
      }
        return items
     },
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {    
  },
  created: function() {

    this.items.forEach(item =>{
      this.pdfItems.push(item)
    })
    
    const item = this.items.filter(item => item.season == 'Totale')
    this.items.splice(this.items.length-1)
    this.totalRow = item
   
  },
  methods: {
  
  printPDF()
    {
      const items = this.pdfItems
      const doc = new jsPDF()
      var page = 1
      
      const pages = parseInt(items.length / 50) == items.length / 50 ? parseInt(items.length / 50) : parseInt(items.length / 50) + 1
      const col1 = 5
      const col2 = 17
      const col3 = 38
      const col4 = 75
      const col5 = 105
      const col6 = 140
      const col7 = 180
      const col8 = 202

      let rowIndex = 1
      let pageIndex = 1
      const initRow = 25
      let row = initRow      
      const header = () =>{

              const date1 = new Date(this.pdf.date1).toLocaleString('en-GB').substring(0,10)
              const date2 = new Date(this.pdf.date2).toLocaleString('en-GB').substring(0,10)

              doc.setDrawColor(0)
              doc.setFillColor(0,0,153)
              doc.roundedRect(3, 4, 205, 5,1,1,'FD')      

              doc.setFontSize(10)
              doc.setFont("helvetica",'bold')
              doc.setTextColor(255, 255, 255)  
              doc.text('ANALISI VENDITE DAL  ' + date1  + ' AL ' + date2 , 110, 7.5,null,null,'center');
              doc.setTextColor(0, 0, 0)  

              doc.setFontSize(7)
              doc.setFont("helvetica",'italic')
              //doc.text( 'Tipo raggruppamento ' + this.grouping[this.group_by].group_by,  150, 10.5,null,null,'right');
              doc.setFont("helvetica",'normal')

      }


      const columns = () =>
      {
     
        const row = 17

        doc.setFontSize(10)
        doc.setDrawColor(0)
        doc.setFillColor(224,224,224)
        
        //doc.roundedRect(5, row - 1, 20, 7,1,1,'FD')              
      
        doc.roundedRect(col1 -2, row - 4.5, 203, 7,1,1,'FD') 
        doc.setFont("helvetica",'bold')
        doc.text('ANNO', col1,row)
        doc.text('STAGIONE', col2, row)
        doc.text('REPARTO', col3, row)
        doc.text('PRODOTTI', col4, row,null,null,'right')
        doc.text('VAL. INIZIALE €', col5, row,null,null,'right')
        doc.text('VAL. VENDUTO €', col6, row,null,null,'right')
        doc.text('VARIAZIONE VAL. €', col7, row,null,null,'right')
        doc.text('SC. MEDIO', col8, row,null,null,'right')

        doc.setFont("helvetica","normal");

      }
      const footer = () =>
      {
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  105, 290, null, null, "center");
       
      }
      
      header()
      columns()
      footer()

      doc.setFont("helvetica","normal"); 
      items.forEach(item => {
      
                       
        doc.setFontSize(10)              
        doc.setFont("helvetica","normal");  
        if(item.season == 'Totale')
        {
          doc.setFont("helvetica","bold"); 
          doc.setFontSize(12)  
          row++             
        }  

        if(item.season_year)
        {
          doc.text(item.season_year.toString(), col1, row)
        
        }
        
        doc.text(item.season ,col2, row)
        
        if(item.department)
        {
          doc.text(item.department, col3, row)
        }

        doc.text(this.fmt2(item.qty), col4, row,null,null,'right')
        doc.text(this.fmt1(item.totalRetail), col5, row,null,null,'right')

        doc.text(this.fmt1(item.totalSold), col6, row,null,null,'right')
        doc.text(this.fmt1(item.priceDifference), col7, row,null,null,'right')
        doc.text(item.totalDiscount.toString() + '%', col8, row,null,null,'right')
       
        if(item.season == 'Total')
        {
          
                
          //doc.roundedRect(col + 9, row - 3, 185, 4,2,2)
          
          //doc.setFontSize(10)
        }

        if(pageIndex == 50 && rowIndex < items.length)
        {
          page++  
          doc.addPage("a4");
          header()
          footer()
          row = initRow
          rowIndex++
          pageIndex = 1
        }
        else
        {
          row = row + 5
          rowIndex++
          pageIndex++
        }
        
      })
       
      window.open(doc.output('bloburl'), '_blank');
      //this.spinner2 = false
    },
  


    
  
  
  
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 600px;
overflow   : auto;
}
.pointer:hover
{
  background-color: rgb(214, 225, 226);
  color: white;
  cursor: pointer;
}
.list-group-item
{
  font-size: 18px;
}

.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    

 }

 .test tr:nth-child(1) th{

  background-color : rgb(206, 213, 237) !important;
  color            : rgb(18, 17, 20) !important

}
.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 25px;
    background   :#e9fce9;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  _border-radius : 0 0 0 10px;
}
.table th:last-child
{
  _border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.grp{
  font-size    : 18px;
  color        : darkmagenta;
}
.form-check-label{
  cursor:pointer
}
.btn-export
{
  background-color: saddlebrown;
  color           :whitesmoke
}
.btn-pdf
{
  background-color: blueviolet;
  color           :whitesmoke
}

.card-header
{
  height: 45px;
}
.table-light{
  background-color : orange ;
}
</style>